// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboards_dashboardContainer__CtXsC","createDashboardText":"Dashboards_createDashboardText__c3PoM","autoSaving":"Dashboards_autoSaving__TA5jY"};